/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
// Ember imports
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
// Internal imports
import Scopes from '@linc-technologies/linced-common/enums/scopes';

export default class ProfileBannerBadgesDialog extends Component {
  @service
  permissions;

  @service
  strings;

  @service
  toaster;

  Scopes = Scopes;

  // Component versioning
  @tracked visualStyle = 'v1';

  deleteBadgeDialogOpen = false;

  @tracked
  badgeDialogOpen;

  @computed('school.id')
  get progressStrings() {
    return this.strings.getProgressStrings(this.school);
  }

  @action
  deleteBadge(badge) {
    badge
      .destroyRecord()
      .then(() => {
        this.toaster.success('Badge deleted successfully!');
        this.badgeDialogOpen = false;
      })
      .catch(() => {
        this.toaster.error('Error deleting badge. Please try again.');
      });
  }
}
